/// <amd-module name="Reporting/BoardsCommon/ReportQueryHelper" />
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { IVssPageContext } from "VSS/Platform/Context";

export function resetQueryCache(pageContext: IVssPageContext) {
    // TODO: Move usage of query service to retire the Dashboard query cache, now that widgets live outside Dashboard page.
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    queryCache.resetCache();
}
